import React, { useEffect, useContext, useState } from "react";
import { SuperSEO } from "react-super-seo";
import axios from "axios";
import { Card, Carousel, Col, ListGroup, Row } from "react-bootstrap";
import PsContext from "../../../context";

import { ServiceUrl } from "../../../utils/serviceUrl";
import { getFileLiveUrl, LOADER_LOGO, upperCase } from "../../../utils";

const CourseList = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  const deptId = props.match.params.id;
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    setDataList([]);
    loadData();
  }, [props.pageId]);

  const loadData = () => {
    setLoader(true);

    axios
      .get(ServiceUrl.DEPT.COURSES + "?academic_department=" + deptId)
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        }
        setLoader(false);
      });
  };

  return (
    <>
      {loader && (
        <center className="py-5">
          <img src={LOADER_LOGO.default} />
        </center>
      )}

      {dataList.length > 0 && (
        <div>
          <h4 className="text-center mb-4">Courses Offered</h4>
          <table className="table table-bordered table-hover">
            <thead>
              <tr className="bg-light">
                <th>Programme Name</th>
                <th>Programme Type</th>
              </tr>
            </thead>
            <tbody>
              {dataList.map((item, i) => {
                return (
                  <tr key={i}>
                    <td>
                      {item.degreename}-{item.name}
                    </td>
                    <td>{upperCase(item.dept_type)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default CourseList;
